import type { SVGProps } from "react";
export interface CalendarBookmarkIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function CalendarBookmarkIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: CalendarBookmarkIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M21 6.875a1.125 1.125 0 0 1 0 2.25H3a1.125 1.125 0 0 1 0-2.25z"
      />
      <path
        fill={color}
        d="M19.875 9.039V6c0-.996-.778-1.81-1.76-1.87a1.124 1.124 0 0 1-2.233-.005H8.118a1.125 1.125 0 0 1-2.235.005A1.874 1.874 0 0 0 4.125 6v12c0 1.036.84 1.875 1.875 1.875h5l.115.006a1.125 1.125 0 0 1 0 2.239l-.116.005H6A4.125 4.125 0 0 1 1.875 18V6a4.12 4.12 0 0 1 4.006-4.119 1.125 1.125 0 0 1 2.237-.006h7.764a1.125 1.125 0 0 1 2.235.006 4.12 4.12 0 0 1 4.008 4.12v3.038a1.125 1.125 0 0 1-2.25 0m1 5.46a.376.376 0 0 0-.375-.375h-4a.375.375 0 0 0-.375.375v5.606l1.627-1.445.17-.125a1.12 1.12 0 0 1 1.325.125l1.628 1.445zm2.25 6.998c0 1.314-1.456 2.05-2.502 1.37l-.203-.156-1.92-1.706-1.92 1.706c-1.049.931-2.705.188-2.705-1.214V14.5a2.625 2.625 0 0 1 2.625-2.625h4a2.626 2.626 0 0 1 2.625 2.625v6.998Z"
      />
    </svg>
  );
}
